let appClass = '';
const ios = ['iPhone', 'iPad'];
let os = navigator.userAgent.match(/iphone|ipad|android/i);
if (os) {
  os = os[0];
  if (ios.indexOf(os) + 1) {
    appClass = 'android';
  }
  if (os === 'Android') {
    appClass = 'ios';
  }
  if (appClass) {
    document.querySelector('.app-icon.' + appClass).parentNode.style.display = 'none';
  }
}
